<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">用户注册</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li>
            申请者在申请页面输入个人信息，并打印“申请用纸“，取得管理人的许可
            <ul>
              <li>
                ※
                企业信息为必填信息，当企业区分（企业Master中设定）为【SHARP】时，事业本部及事业部信息必须填写，其他类别的企业该两项不可输入
              </li>
              <li>
                ※
                申请人的个人信息的采集及使用需要取得申请人的同意（点击【個人情報利用について】链接可以打开一个个人信息利用说明页面，页面内容稍后由SJL提供，申请者需要確定“同意”才能申请）
              </li>
            </ul>
          </li>
          <li>
            申请者需要将得到许可的【申请用纸】（盖过章）进行上传，同时系统发邮件通知SJL
            User管理担当用户
            <ul>
              <li>※ 【申请用纸】上传时需要確定，新注册的用户的 【User ID】</li>
            </ul>
          </li>
        </ol>
        <h3>输出文档</h3>
        <ol>
          <li>
            【申请用纸】
            <ul>
              <li>
                ※
                请参照日方提供的资料【新規ユーザー申込】文件夹中的4种（根据用户企業名称区分+使用语言区分）
              </li>
            </ul>
          </li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style scoped></style>
